// @flow
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import React, { Component } from 'react';
import _ from 'lodash';
import { Form, Grid } from 'semantic-grab-ui/src';
import FormInputWithError from 'omega-rtc/components/form/FormInputWithError';
import ProgressBar from 'omega-rtc/components/custom/ProgressBar';

type Props = {
  model: TridentCampaignDetails,
  handleInputChange: Function,
  handleControlBlur: Function,
};

type State = {
  budgetUsage: number,
};

class BudgetForm extends Component<Props, State> {
  state = {
    budgetUsage: 0,
  };

  componentDidMount() {
    // Set the budgetUsage in the state as the 'budgets' in the model will be modified by input handler
    const budgetUsage = _.get(this.props.model, 'budgets[0].usage', 0);
    this.setState({ budgetUsage });
  }

  handleBudgetChange = (event) => {
    const parsedValue = parseFloat(event.target.value);

    // Ensure the value is a valid number and greater than 0
    if (parsedValue > 0) {
      this.props.handleInputChange({}, {
        name: 'budgets[0]',
        value: { key: 'campaignBudget', amount: parsedValue },
      });
    } else {
      this.props.handleInputChange({}, { name: 'budgets', value: undefined });
    }
  };

  render() {
    const { model, handleControlBlur } = this.props;
    // At the moment, only single budget supported
    const budgetAmount = _.get(model, 'budgets[0].amount', 0);
    const budgetUsage = this.state.budgetUsage;
    const shouldDisplayBudgetUsage = (budgetAmount > 0 && budgetUsage > 0);

    return (
      <React.Fragment>
        <Grid>
          <Grid.Column width={4}>
            <FormInputWithError
              {...this.props}
            >
              <Form.Input
                type="number"
                label={'Budget'}
                required={false}
                value={budgetAmount}
                onChange={this.handleBudgetChange}
                onBlur={handleControlBlur}
              />
            </FormInputWithError>
            {budgetAmount === 0 && <label style={{
              position: 'absolute',
              right: 25,
              top: 55,
              fontSize: 11,
              color: '#00b140',
              background: '#fff',
            }}
            >Unlimited</label>}
          </Grid.Column>
          {shouldDisplayBudgetUsage && <Grid.Column width={8}>
            <ProgressBar label={'Budget Usage'} usage={budgetUsage} limit={budgetAmount} />
          </Grid.Column>
          }
        </Grid>
      </React.Fragment>
    );
  }
}

export default BudgetForm;
